export default __webpack_public_path__ + "static/media/pranjal.a9a15a29.svg";